import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PostHogProvider } from 'posthog-js/react';
import App from './App.tsx';
import './index.css';

const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const posthogHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

// Only initialize PostHog if environment variables are present and it's not already initialized
const shouldInitPostHog = posthogKey && posthogHost && !(window as any).posthog;

const options = shouldInitPostHog ? {
  api_host: posthogHost,
  loaded: (posthog: any) => {
    if (import.meta.env.DEV) {
      // Disable auto-capture in development to reduce noise
      posthog.opt_out_capturing();
    }
  }
} : undefined;

const root = createRoot(document.getElementById('root')!);

// Render app with or without PostHog based on initialization check
root.render(
  <StrictMode>
    {shouldInitPostHog ? (
      <PostHogProvider 
        apiKey={posthogKey}
        options={options}
      >
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )}
  </StrictMode>
);
